// extracted by mini-css-extract-plugin
module.exports = {"scss":"App_scss__1X-I4"};